import axios from "axios";
import React, { useState } from "react";
import { ChatState } from "../../Context/ChatProvider";
import UserBadgeItem from "../userAvatar/UserBadgeItem";
import UserListItem from "../userAvatar/UserListItem";
import Closeicon from "../../images/Closeicon";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import { getAuthConfig } from "../../utils/functions";


const GroupChatModal = ({children}) => {
    const [groupChatName, setGroupChatName] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenCreateDelete, setIsOpenCreateDelete] = useState(false);
    const [userForDelete, setUserForDelete] = useState(null);

    const { user, chats, setChats, openCreateGroupChat, setOpenCreateGroupChat, showToast } = ChatState();

    const handleGroup = (userToAdd) => {
        if (selectedUsers.includes(userToAdd)) {
            showToast ( 'warning', 'The user is already in this group. Choose next one' );
            return;
        }
        setSelectedUsers([...selectedUsers, userToAdd]);
    };
    const handleSearch = async (query) => {
        if (query.match(/[<>&]/)) {
            showToast('warning', 'Please avoid using <, >, & characters.');
            return 
        }
        setSearch(query.replace(/[<> &]/g, ''));
        if (!query) {
            return;
        }
        try {
             if(query.length < 6) {
                setSearchResult([]);
                return;
            }
            setLoading(true);
            const config = {headers: { Authorization: `Bearer ${user.token}`} };
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/user?search=${search}`, config);
            setLoading(false);
            setSearchResult(data);
        } catch (error) {
            showToast ('danger', 'Failed to Load the Search Results');
        }
    };

    const handleDelete = () => {
        setSelectedUsers(selectedUsers.filter((sel) => sel._id !== userForDelete._id));
    };
    const setIsOpenCreateDeleteFunction =(u)=> {
        setUserForDelete(u);
        setIsOpenCreateDelete(true)
    }
    const handleSubmit = async () => {
        if (loading) return;
        if (!groupChatName || !selectedUsers) {
            showToast ('warning', 'Please fill all the fields');
            return;
        }
        if (selectedUsers.length < 2) {
            showToast (
                'warning', 'Group contains at least 3 groupmember including you'
            );
            return;
        }
        const chatNameExist = chats.find(chatName => chatName.chatName === groupChatName);
        if (chatNameExist) {
            showToast ( 'warning', 'This name is already is in DataBase. Choose another');
            return;
        }

        try {
            setLoading(true);
            if (!user || !user.token) {
                throw new Error("No authentication token found");
            }
            const config = getAuthConfig(user.token);
            const { data } = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/chat/group`,
                {
                    name: groupChatName,
                    users: JSON.stringify(selectedUsers.map((u) => u._id)),
                },
                config
            );
            setChats([data, ...chats]);
            setOpenCreateGroupChat(false);
            showToast ('success', 'New Group Chat Created!' );
            setGroupChatName("");
            setSelectedUsers([]);
            setSearchResult([]);
            setSearch("");
        } catch (error)  {
            const errorMessage = error.response?.data?.message || 'Failed to create group';
            showToast('danger', errorMessage);
        } finally {
            setLoading(false);
        }
    };
   
    return (
        <>
            <span className='modal_group_chat'>{children}</span>
                { openCreateGroupChat && <div className=' create_group_chat' >
                <div className='modalOverlay'></div>
                <div className='dialog_alert modal_section'>
                    <p className='modal_header'>Create Group Chat</p>
                    <button className='close_button' onClick={()=>setOpenCreateGroupChat(false)} ><Closeicon /></button>
                    <div className='modal_body' >
                        <div className='form_control'>
                            <input
                                className='updateInput'
                                placeholder="Chat Name"
                                onChange={(e) => setGroupChatName(e.target.value)}
                                value={groupChatName}
                            />
                        </div>
                        <div className='form_control'>
                            <input
                                className='updateInput'
                                placeholder="Add Users: John, Salman, Jane"
                                onChange={(e) => handleSearch(e.target.value)}
                                value={search}
                            />
                            <div className='charakters_left' style={{ 
                                    left: (search.length > 2 && search.length < 7) ? `${search.length * 17}px` : 0, 
                                    display: (search.length > 2 && search.length < 6) ? "block" : "none"
                                }} variant="ghost"  >
                                <i className="fas fa-search"></i>
                                <p className = 'searchUser'>
                                    {6 - search.length + " more characters"}
                                </p>
                            </div>
                        </div>
                        <div  className='badges_box' >
                            {selectedUsers.map((u) => (
                                <UserBadgeItem
                                    key={u._id}
                                    user={u}
                                    handleFunction={()=>setIsOpenCreateDeleteFunction(u)}
                                />
                            ))}
                            <ConfirmModal isOpen={isOpenCreateDelete} onConfirm={handleDelete} content="Do you really want to remove the user from the list?" onClose={()=>setIsOpenCreateDelete(false)}/>
                        </div>
                        <div className='items_box'>
                            {loading ? (
                                <div>Loading...</div>
                            ) : (
                                searchResult
                                    ?.slice(0, 4)
                                    .map((user) => (
                                        <UserListItem 
                                            key={user._id}
                                            user={user}
                                            handleFunction={() => handleGroup(user)}
                                        />
                                    ))
                            )}
                        </div>
                    </div>
                    <div className='modal_footer'>
                        <button className="button" onClick={()=>setIsOpen(true)}>Create Chat</button>
                        <ConfirmModal isOpen={isOpen} onConfirm={handleSubmit} content="Do you really want to create a new chat?" onClose={()=>setIsOpen(false)}/>
                    </div>
                </div>
             </div>  }
        </>
    )
}
export default GroupChatModal
